import {useState} from 'react';
import { Stack, Dialog, DialogTitle, DialogContent, TextField, DialogActions, DialogContentText, Box, FormControl, InputLabel, MenuItem, Button} from '@mui/material';
import Select from '@mui/material/Select';
import Rating from '@mui/material/Rating';
import { useHistory } from 'react-router-dom';
import './styles/Home.css';
import { useForm } from "react-hook-form";
import PlayCircleOutlineRoundedIcon from '@mui/icons-material/PlayCircleOutlineRounded';




export default function SinglePlayerRoomSetup() {
    const [botSetting, setBotSetting] = useState(false);

    return (<>

        <Button className='btn' color='inherit' variant="outlined" onClick={() => setBotSetting(true)} endIcon={<PlayCircleOutlineRoundedIcon/>}>
            Single Player
        </Button>

        <Dialog
            fullWidth={true}
            maxWidth='xs'
            open={botSetting}
            onClose={() => setBotSetting(false)}
        >
            <DialogTitle> Single Player </DialogTitle>
            <DialogContent>

                <DialogContentText>
                    Choose your game modes
                </DialogContentText>

                <Box sx={{ mt: 3, mb: -2 }}>

                    <GameSetting/>

                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={() => setBotSetting(false)}>Close</Button>
            </DialogActions>
        </Dialog>
    </>
    )
}

export function GameSetting() {
    const Modes = ['Blindfold', 'Normal', 'Custom'];
    const Colors = ['White', 'Black', 'Random'];
    const Hints = ['One', 'Two', 'Three', 'Four', 'Five', 'Ten'];
    const botLevels = {
        1: '600 - 800',
        2: '1000 - 1200',
        3: '1400 - 1600',
        4: '1800+',
        5: '2500+'
    }
    
    // const timeControls = ['3 v 3', '5 v 5', '10 v 10']

    const [username, setUsername] = useState('');
    const [hint, setHint] = useState('One')
    const [hover, setHover] = useState(-1);
    const [gameMode, setGameMode] = useState('Normal');
    const [color, setColor] = useState('White');
    const [botLevel, setBotLevel] = useState(2);
    const history = useHistory();
    // const [timeControl, setTimeControl] = useState('5 v 5');
    const { handleSubmit } = useForm();

    function handleChangeMode(event) {
        setGameMode(event.target.value);
    };

    function handleChangeColor(event) {
        setColor(event.target.value);
    };

    function handleChangeHint(event) {
        setHint(event.target.value);
    };

    // function handleChangeTime(event) {
    //     setTimeControl(event.target.value);
    // };

    function handleChangeUsername(event) {
        setUsername(event.target.value);
    }

    const Onsubmit = () => {
        const data = {p1Mode: gameMode,
        p1Hint: hint,
        p1Color: color.toLowerCase(),
        botLevel: botLevel,
        // timeControl: timeControl,
        username: username
    };
    history.push({pathname: '/single_player', state: data});
    
    }



    return (
        <div align="left">
        <form onSubmit={handleSubmit(Onsubmit)}>
            <Stack spacing={2}>
            <Stack direction={{ xs: 'column', sm: 'row' }}>
            <FormControl sx={{ m: 1, minWidth: { xs: '100%', sm: 200 } }} size="medium" register>
                <InputLabel id="mode"> Your Mode ... </InputLabel>
                <Select
                    labelId="mode"
                    id="mode"
                    value={gameMode}
                    label="Game Mode"
                    onChange={handleChangeMode}
                >
                    {Modes.map((mode) => {
                        return (
                            <MenuItem value={mode}> {mode} </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
            { (gameMode==='Custom')? (
            <FormControl sx={{ m: 1, minWidth: { xs: '100%', sm: 100 } }} size="medium">
                <InputLabel id="hint1">Hint Allowed ...</InputLabel>
                <Select
                    labelId="hint1"
                    id="hint1"
                    value={hint}
                    label="Game Mode"
                    onChange={handleChangeHint}
                >
                    {Hints.map((mode) => {
                        return (
                            <MenuItem value={mode}> {mode} </MenuItem>
                        );
                    })}
                </Select>
            </FormControl> ) : ''}   
            </Stack>

            <Stack direction={{ xs: 'column', sm: 'row' }}>
            <FormControl sx={{ m: 1, minWidth: { xs: '100%', sm: 150 } }} size="medium">
                <InputLabel id="color">Your Color ...</InputLabel>
                <Select
                    labelId="color"
                    id="color"
                    value={color}
                    label="Game Mode"
                    onChange={handleChangeColor}
                >
                    {Colors.map((mode) => {
                        return (
                            <MenuItem value={mode}>
                                {mode} </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>

            {/* <FormControl sx={{ m: 1, minWidth: 100 }} size="medium">
                <InputLabel id="timeControl">Time Control ...</InputLabel>
                <Select
                    labelId="timeControl"
                    id="timeControl"
                    value={timeControl}
                    label="Game Mode"
                    onChange={handleChangeTime}
                >
                    {timeControls.map((mode) => {
                        return (
                            <MenuItem value={mode}>
                                {mode} </MenuItem>
                        );
                    })}
                </Select>
            </FormControl> */}


            </Stack> 
            <Box sx={{  minWidth: 150 }}>
            <Stack direction='row' sx={{ ml: 1.2, flexWrap: 'wrap' }} alignItems='center' spacing='0.6em'>
                <InputLabel id="mode"> Bot rating :  </InputLabel>
                <Rating
                    name="botLevel"
                    value={botLevel}
                    onChange={(event, newValue) => {
                    setBotLevel(newValue);
                    }}
                    onChangeActive={(event, newHover) => {
                        setHover(newHover);
                      }}

                />

                <InputLabel id='mode'> {botLevels[hover !== -1 ? hover : botLevel]} </InputLabel>
            </Stack>
            </Box>
            
            
            
               

            <FormControl size="medium">
                <TextField
                    sx={{ m: 1 }}
                    fullWidth
                    label="Your Name"
                    error={Boolean(username.length === 0)}
                    helperText={username.length === 0 ? 'Please pick your name' : `Goodluck ${username}!`}
                    onChange={handleChangeUsername}
                />
            </FormControl>

            <Button
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            >
                Start Game
            </Button>
            </Stack>
        </form>
        </div>
    );
}